
import { Grid, IconButton, Tooltip } from '@mui/material';
import './item-card.css';
import { getDetailsById } from "src/services/knowledgebase.service";
import * as componentActions from 'src/redux/actions/knowledgebases';
import { useDispatch } from 'react-redux';
import { Search } from '@mui/icons-material';
import { PapiroConsole } from 'src/utils/papiroConsole';

const KnowledgeBaseCard = (props) => {
    const { knowledgebase, intl, history, lang, setLoading, setNotification } = props

    const dispatch = useDispatch()

    const goToKnowledgeBaseEdit = async () => {
        if (knowledgebase && knowledgebase.id) {
            setLoading(true)
            const response = await getDetailsById(knowledgebase.id)
            if (response.success && response.data) {
                setLoading(false)
                dispatch(componentActions.addCurrent(response.data))
            }
            setLoading(false)
            history.push(`/${lang}/knowledgebase-edit`)
        }
    }

    const goToKnowledgeBase = async () => {
        if (knowledgebase && knowledgebase.id) {
            if (!knowledgebase.onlyinternaluse) {
                localStorage.setItem("generalSearchKnowledgeBase", JSON.stringify(knowledgebase))
                window.open(`${window.location.origin}/${lang}/knowledgebases-external`, "_blank", "noopener,noreferrer")
            } else {
                setNotification("error", intl.formatMessage({ id: "For.internal.use.only" }))
            }
        }
    }

    return (
        <Grid item container spacing={2} lg={12} md={11} sm={11} xs={12} className="cardItem" direction="row" alignItems="center" >
            <Grid item lg={2} md={2} sm={4} xs={4} style={{ display: "flex", alignItems: "center" }} onClick={goToKnowledgeBaseEdit}>
                <span className="boldLine-two" style={{ cursor: "pointer" }}>
                    ID {knowledgebase.id}
                </span>
            </Grid>
            <Grid item lg={1} md={2} sm={1} xs={1} className='moreActions'>
                <Tooltip title={<h5>{intl.formatMessage({ id: "view.knowledgebase" })}</h5>}>
                    <IconButton aria-label="table-popup" onClick={goToKnowledgeBase} >
                        <Search />
                    </IconButton>
                </Tooltip>
            </Grid>
            <Grid item lg={4} md={4} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                <span style={{ wordBreak: "break-word" }}>{knowledgebase.title}</span>
            </Grid>
            <Grid item lg={5} md={5} sm={6} xs={6} style={{ display: "flex", alignItems: "center" }}>
                <span style={{ wordBreak: "break-word" }}>{knowledgebase.description}</span>
            </Grid>
        </Grid>
    )
}

export default KnowledgeBaseCard